import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { useState } from "react";
import { ReoccurringTemplateMeetingsForm } from "./ReoccurringTemplateMeetingsForm";
import type { Agenda } from "@repo/types";
import { MEETING_MOTIF } from "@/lib/constants";

export const ReoccurringTemplateMeetingsDialog = ({
  tenantId,
  template,
  open: outerOpen,
  setOpen: outerSetOpen,
  templates,
}: {
  tenantId: string;
  template?: Agenda;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  templates?: Agenda[];
}) => {
  const [innerOpen, innerSetOpen] = useState(false);

  const open = outerOpen ?? innerOpen;
  const setOpen = outerSetOpen ?? innerSetOpen;

  const handleOpenChange = () => setOpen(!open);

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent preventClickout preventEscape>
        <DialogHeader className={MEETING_MOTIF}>
          <DialogTitle>Generate Reoccurring Meetings</DialogTitle>
        </DialogHeader>
        <ReoccurringTemplateMeetingsForm
          tenantId={tenantId}
          template={template}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          withinDialog
          templates={templates}
        />
      </DialogContent>
    </Dialog>
  );
};
